import React from 'react';
import PropTypes from 'prop-types';

// Temperature ramp (dark green -> yellow -> orange -> red), one stop per bar.
const IMPACT_RAMP = [
  '#3d9636',
  '#57ab35',
  '#78bd35',
  '#9ccb37',
  '#c2d63a',
  '#e4dc3d',
  '#f2c93a',
  '#f5ab31',
  '#f38d2a',
  '#ee6c26',
  '#e84a25',
  '#e02b3c',
];
const IMPACT_INACTIVE = '#e7eaea';
const IMPACT_MIN_HEIGHT = 10;
const IMPACT_MAX_HEIGHT = 30;

export const ImpactBar = ({ value }) => {
  const barCount = IMPACT_RAMP.length;
  const clamped = Math.min(1, Math.max(0, value || 0));
  const lit = Math.ceil(clamped * barCount);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3 }}>
      {IMPACT_RAMP.map((color, index) => (
        <div
          key={index}
          style={{
            width: 6,
            height: Math.round(IMPACT_MIN_HEIGHT + ((IMPACT_MAX_HEIGHT - IMPACT_MIN_HEIGHT) * index) / (barCount - 1)),
            borderRadius: 3,
            flexShrink: 0,
            backgroundColor: index < lit ? color : IMPACT_INACTIVE,
          }}
        />
      ))}
    </div>
  );
};

ImpactBar.propTypes = {
  value: PropTypes.number,
};

const ATTAINABILITY_BAR_COUNT = 15;
// Height by distance from the peak bar; anything further out gets the base height.
const ATTAINABILITY_PEAK_HEIGHTS = { 0: 28, 1: 17, 2: 11 };
const ATTAINABILITY_BASE_HEIGHT = 7;
const ATTAINABILITY_COLOR = '#4f4f4f';

const attainabilityLabelStyle = {
  fontSize: 8,
  fontWeight: 600,
  letterSpacing: 0.8,
  color: '#7c8a8d',
};

export const AttainabilityBar = ({ value }) => {
  // attainability is stored inverted (1 = most attainable), so high values peak at the EASY end
  const clamped = Math.min(1, Math.max(0, value || 0));
  const peak = Math.round((1 - clamped) * (ATTAINABILITY_BAR_COUNT - 1));
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <span style={{ ...attainabilityLabelStyle, marginRight: 4 }}>EASY</span>
      {Array.from({ length: ATTAINABILITY_BAR_COUNT }, (_, index) => (
        <div
          key={index}
          style={{
            width: 4,
            height: ATTAINABILITY_PEAK_HEIGHTS[Math.abs(index - peak)] || ATTAINABILITY_BASE_HEIGHT,
            borderRadius: 2,
            flexShrink: 0,
            backgroundColor: ATTAINABILITY_COLOR,
          }}
        />
      ))}
      <span style={{ ...attainabilityLabelStyle, marginLeft: 4 }}>HARD</span>
    </div>
  );
};

AttainabilityBar.propTypes = {
  value: PropTypes.number,
};
